import { render, staticRenderFns } from "./ReminderPlanUpdate.vue?vue&type=template&id=e2517720&"
import script from "./ReminderPlanUpdate.vue?vue&type=script&lang=js&"
export * from "./ReminderPlanUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports